<template>
    <div>
        <el-breadcrumb separator-class="uil uil-angle-right-b m-breadcrum">
            <el-breadcrumb-item :to="{ name: 'Dashboard' }"><i class="uil uil-home"></i></el-breadcrumb-item>
            <el-breadcrumb-item to="/settings">Company Settings</el-breadcrumb-item>
            <el-breadcrumb-item >Inventory</el-breadcrumb-item>
        </el-breadcrumb>

        <InventorySettings />
    </div>
</template>
<script>
import InventorySettings from '@/views/Settings/Inventory/components/InventorySettings';

export default{
    name: "Inventory",
    components:{
        InventorySettings
    },
}
</script>